const images = {
  botImage: require("./bot-image.png"),
  Alice: require("./bot-image-Alice.png"),
  Endy: require("./bot-image-Endy.png"),
  Mario: require("./bot-image-Mario.png"),
  Robbi: require("./bot-image-Robbi.png"),
  Fatima: require("./bot-image-Fatima.jpg"),

  ChooseOnboardingWelcomeMsg: require("./choose-onboarding-welcome-msg.jpg"),

  OnboardingBotSmall: require("./onboarding-small-bot.png"),
  OnboardingBotMessage: require("./onboarding-bot-message.png"),
  OnboardingBotMessage2: require("./onboarding-bot-message2.png"),

  OnboardingChatFooterDS: require("./onboarding-chat-footer-DS.png"),
  OnboardingChatHeaderDS: require("./onboarding-chat-header-DS.png"),
  OnboardingChatTestDS: require("./onboarding-chat-test-DS.png"),

  OnboardingChatFooterMB: require("./onboarding-chat-footer-MB.png"),
  OnboardingChatHeaderMB: require("./onboarding-chat-header-MB.png"),
  OnboardingChatTestMB: require("./onboarding-chat-test-MB.png"),

  OnboardingChatInfoMB: require("./onboarding-chat-info-MB.png"),
  OnboardingChatInfoDS: require("./onboarding-chat-info-DS.png"),

  OnboardingStatistictCertificate: require("./onboarding-statistic-certificate.png"),
  OnboardingStatisticCharts: require("./onboarding-statistic-charts.png"),
  OnboardingStatisticLeaderboard: require("./onboarding-statistic-leaderboard.png"),
  OnboardingStatisticTime: require("./onboarding-statistic-time.png"),

  OnboardingBot: require("./bot-image-big-Robbi.jpg"),
  OnboardingBotAlice: require("./bot-image-big-Alice.jpg"),
  OnboardingBotEndy: require("./bot-image-big-Endy.jpg"),
  OnboardingBotMario: require("./bot-image-big-Mario.jpg"),
  OnboardingBotFatima: require("./bot-image-big-Fatima.jpg"),

  OnboardingBotSms: require("./onboarding-bot-sms.png"),
  OnboardingBotSms2: require("./onboarding-bot-sms2.png"),
  OnboardingBotSms3: require("./onboarding-bot-message3.png"),
  OnboardingBotSms4: require("./onboarding-bot-message4.png"),
  OnboardingBotSms5: require("./onboarding-bot-message5.png"),

  LessonOnboardingMB1: require("./lesson-onboarding-MB1.png"),
  LessonOnboardingDS1: require("./lesson-onboarding-DS1.jpg"),

  LessonOnboardingMB2: require("./lesson-onboarding-MB2.png"),
  LessonOnboardingDS2: require("./lesson-onboarding-DS2.jpg"),

  LessonOnboardingMB3: require("./lesson-onboarding-MB3.png"),
  LessonOnboardingDS3: require("./lesson-onboarding-DS3.jpg"),

  LessonOnboardingMB4: require("./lesson-onboarding-MB4.png"),
  LessonOnboardingDS4: require("./lesson-onboarding-DS4.jpg"),

  LessonOnboardingMB5: require("./lesson-onboarding-MB5.png"),
  LessonOnboardingDS5: require("./lesson-onboarding-DS5.jpg"),

  LessonOnboardingDS6: require("./lesson-onboarding-DS6.jpg"),
  LessonOnboardingDS7: require("./lesson-onboarding-DS7.jpg"),
  LessonOnboardingDS8: require("./lesson-onboarding-DS8.jpg"),
  LessonOnboardingDS9: require("./lesson-onboarding-DS9.jpg"),
  LessonOnboardingDS10: require("./lesson-onboarding-DS10.jpg"),
  LessonOnboardingDS11: require("./lesson-onboarding-DS11.jpg"),
  LessonOnboardingDS12: require("./lesson-onboarding-DS12.jpg"),
  LessonOnboardingDS13: require("./lesson-onboarding-DS13.jpg"),
  LessonOnboardingDS14: require("./lesson-onboarding-DS14.jpg"),
  LessonOnboardingDS15: require("./lesson-onboarding-DS15.jpg"),

  MenuDropDownPreAssessment: require("./menu-dropdown-pre-assessment.png"),

  RemoveTagTrash: require("./remove-tag-trash.png"),
  InstructionRolePlay: require("./instruction-role-play.jpg"),
  CoachingModel: require("./coaching_model.jpg"),
  AudioOnlyAvatar: require("./audio-only-avatar.jpg"),
  PioneersPopupVideoFemale: require("./pioneers-popup-female.mp4"),
  PioneersPopupVideoMale: require("./pioneers-popup-male.mp4"),
};

export default images;
